export default __webpack_public_path__ + "static/media/7.876a1d39.md";